import React from 'react';
import './radio-list.css'; // Import the CSS file
import InfoIcon from './InfoIcon.tsx'; // Import the InfoIcon component

interface RadioOption {
    label: string;
    value: string;
}

interface RadioListProps {
    options: RadioOption[];
    selectedValue: string | null;
    onSelectionChange: (value: string | null) => void;
    groupName: string;
    infoTexts?: Record<string, string>; // ✅ Optional prop for additional information
}

const RadioList: React.FC<RadioListProps> = ({ options, selectedValue, onSelectionChange, groupName, infoTexts }) => {
    const handleRadioChange = (value: string) => {
        if (selectedValue === value) {
            onSelectionChange(null); // ✅ Deselect if clicked again
        } else {
            onSelectionChange(value); // ✅ Select new value
        }
    };

    return (
        <div className="radio-list">
            {options.map((option) => (
                <div key={option.value} className="radio-list__item">
                <input
                    type="radio"
                    id={option.value}
                    name={groupName}
                    value={option.value}
                    checked={selectedValue === option.value}
                    onClick={() => handleRadioChange(option.value)}
                />
                <div className="radio-label-container">
                    <label htmlFor={option.value} className="radio-list__label">
                        {option.label}
                    </label>
                    {infoTexts && infoTexts[option.value] && (
                        <InfoIcon popupText={infoTexts[option.value]} className="info-icon-spacing" />
                    )}
                </div>
            </div>            
            ))}
        </div>
    );
};

export default RadioList;
